import AsyncStorage from "@react-native-async-storage/async-storage";
import { configureStore } from "@reduxjs/toolkit";
import { enableMapSet } from "immer";
import logger from "redux-logger";
import { createTransform, persistReducer, persistStore } from "redux-persist";
import expireReducer from "redux-persist-expire";
import thunk from "redux-thunk";

import { reducers } from "./ducks";
import { checkoutInitialState } from "./ducks/checkout";

enableMapSet();

const persistConfig = {
  key: "@ifeira-root",
  storage: AsyncStorage,
  transforms: [
    expireReducer("checkout", {
      expireSeconds: 60 * 60 * 24,
      autoExpire: true,
      expiredState: checkoutInitialState,
    }),
    createTransform(
      (state: any) => {
        return { ...state, items: Array.from(state.items) };
      },
      (state) => {
        return { ...state, items: new Map(state.items) };
      },
      {
        whitelist: ["checkout"],
      }
    ),
  ],
};

const middlewares: any[] = [thunk];

if (process.env.NODE_ENV === "development") {
  middlewares.push(logger);
}

const persistedReducer = persistReducer(persistConfig, reducers) as typeof reducers;

export const store = configureStore({
  reducer: persistedReducer,
  middleware: middlewares,
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
